import React from 'react';
import spicySvg from "../../assets/img/spicy.svg";

const displaySpicy = (spicy) => {
    if (spicy !== 0) {
      return Array(spicy)
        .fill()
        .map((_, i) => <img key={i} src={spicySvg} alt="spicy" />);
    } else {
      return <span style={{ opacity: "0" }}>none</span>;
    }
  };

  export default displaySpicy;